// extracted by mini-css-extract-plugin
export var formContainer = "_ha-0";
export var message = "_ha-1";